module.exports = __webpack_public_path__ + "static/cercazone_centro4-afffb40c42eca050e77b6562e6e98d76.jpg";